module.exports = function() {
  return new Worker(__webpack_public_path__ + "2a530e2b30adff00aa25.worker.js");
};